import { eventUtils } from '../EventUtils.js';
import { ModelNotificationEvent } from './ModelNotificationEvent.js';
export class AutoCorrectPropertyEvent extends ModelNotificationEvent {
    constructor(target, propertyPath, oldValue, newValue) {
        super(target);
        this.target = target;
        this.propertyPath = propertyPath;
        this.oldValue = oldValue;
        this.newValue = newValue;
    }
}
export class AutoCorrectModelEvents {
    constructor(notifications) {
        this.notifications = notifications;
    }
    propertiesAutoCorrected(listener) {
        this.notifications.subscribe('AutoCorrectProperty', listener);
    }
    propertyAutoCorrected(propertyPath, listener) {
        this.notifications.subscribe('AutoCorrectProperty', eventUtils.filter(listener, event => event.propertyPath === propertyPath));
    }
}
//# sourceMappingURL=AutoCorrectModelEvents.js.map